import { Informer } from '@consta/uikit/Informer'
import { ProgressSpin } from '@consta/uikit/ProgressSpin'
import { Text } from '@consta/uikit/Text'
import type { FC } from 'react'

import { useWellNamesMapper } from '../markersHelpers'
import css from './Mapping.css'
import type { MappingProps } from './types'
import { WellMappingTable } from './WellMappingTable'

export const Mapping: FC<MappingProps> = ({ file, settings, parsedData }) => {
  const { mappedWells, wellsForMapping, updateWellMapping } = useWellNamesMapper(
    file,
    parsedData,
    settings,
  )

  const isDataAbsent = parsedData.dataTable === undefined
  const isAllMapped = mappedWells.length === 0 || mappedWells.every(value => value.mappedTo)

  return (
    <div data-testid="import-markers-mapping" className={css.container}>
      <Text size="s" view="secondary" className={css.mappingText}>
        Маппинг
      </Text>
      {!isDataAbsent ? (
        <div className={css.tableArea}>
          <WellMappingTable
            mappedWells={mappedWells}
            wellsForMapping={wellsForMapping}
            mapWellValue={updateWellMapping}
          />
          {!isAllMapped && (
            <Informer
              className={css.tableInformer}
              view="bordered"
              status="system"
              title="Маркеры без скважин не загрузятся в проект."
              label="Загрузите нужные скважины, затем загрузите снова данный файл для корректного маппинга."
            />
          )}
        </div>
      ) : (
        <ProgressSpin size="xl" className={css.spin} />
      )}
    </div>
  )
}
